import { Component } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-boutique',
    templateUrl: 'boutique.html',
})
export class BoutiquePage {

    private boutique: string;
    private votsisBoutique: any;
    private onCourtBoutique: any;

    constructor(public db: AngularFirestore) {
        this.boutique = 'votsis';
        this.votsisBoutique = [];
        this.onCourtBoutique = [];
    }

    ionViewDidLoad() {
        this.loadBoutiqueImages();
    }

    loadBoutiqueImages() {
        this.db.doc("other/boutique").valueChanges().subscribe(boutique => {
            this.votsisBoutique= boutique['votsis'];
            this.onCourtBoutique= boutique['oncourt'];
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/boutique/boutique.ts